import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Overview from "@/pages/home/components/Overview";
import FilmHighlights from "@/pages/home/components/FilmHighlights";
import ActorFocus from "@/pages/home/components/ActorFocus";
import GenreCompare from "@/pages/home/components/GenreCompare";
import Highlights from "@/pages/home/components/Highlights";
import Guide from "@/pages/home/components/Guide";
import TagIndex from "@/pages/home/components/TagIndex";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-sans text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <FilmHighlights />
        <ActorFocus />
        <GenreCompare />
        <Highlights />
        <Guide />
        <TagIndex />
      </main>
      <SiteFooter />
    </div>
  );
}